import Cookies from 'js-cookie';
import { ACCESS_TOKEN_COOKIE_NAME, isInRole } from '@emarketer/auth';

export function checkForecastPlusAccess() {
  let hasPremiumForecastAccess = false;

  try {
    const currentAccessToken = Cookies.get(ACCESS_TOKEN_COOKIE_NAME);

    if (currentAccessToken) {
      hasPremiumForecastAccess = isInRole(currentAccessToken, 'ii_enhanced_forecast');
    }
  } catch (error) {
    console.error('Error checking forecast access:', error);
  }
  return hasPremiumForecastAccess;
}
